import './assets/ContentCard.css';const e = "#ffffff", r = "#396e75", t = "#e5fdff", o = "#546223", a = "#f0fae5", d = "#a65523", _ = "#fff1e8", l = "#7f3e3e", n = "#ffe2e2", c = "#62625a", g = "#f8f8e7", i = "#38539a", h = "#707070", u = "#c8f8d1", b = "#87c9c8", v = "#5291b1", m = "rgba(82, 145, 177, 0.1019607843)", k = "#445685", s = "#181d61", p = "rgba(24, 29, 97, 0.1019607843)", z = "#5969d6", V = "#ea999d", f = "#b6577e", C = "rgba(182, 87, 126, 0.1019607843)", y = "#7e3e80", w = "#1e247f", B = "rgba(30, 36, 127, 0.1019607843)", G = "#da7600", O = "#107f47", R = "#d91734", W = "_html_1t5uv_75", Y = "_banner_1t5uv_362", A = "_content_1t5uv_351", P = "_header_1t5uv_478", S = "_tag_1t5uv_478", x = "_title_1t5uv_489", j = "_description_1t5uv_500", q = "_footer_1t5uv_512", D = "_seperator_1t5uv_546", E = "_dot_1t5uv_554", F = {
  amwayWhite: e,
  darkBlue: r,
  lightBlue: t,
  darkGreen: o,
  lightGreen: a,
  darkOrange: d,
  lightOrange: _,
  darkRed: l,
  lightRed: n,
  darkYellow: c,
  lightYellow: g,
  darkPurple: i,
  darkGrayOnWhite: h,
  dataVizColor1: u,
  dataVizColor2: b,
  dataVizColor3: v,
  dataVizColor3Background: m,
  dataVizColor4: k,
  dataVizColor5: s,
  dataVizColor5Background: p,
  dataVizColor6: z,
  dataVizColor7: V,
  dataVizColor8: f,
  dataVizColor8Background: C,
  dataVizColor9: y,
  dataVizColor10: w,
  dataVizColor10Background: B,
  dataVizAlertOrange: G,
  dataVizSuccessGreen: O,
  dataVizWarningRed: R,
  "no-visible": "_no-visible_1t5uv_34",
  html: W,
  "theme-border-dark-red": "_theme-border-dark-red_1t5uv_283",
  "theme-border-dark-blue": "_theme-border-dark-blue_1t5uv_287",
  "theme-border-dark-orange": "_theme-border-dark-orange_1t5uv_291",
  "theme-border-dark-green": "_theme-border-dark-green_1t5uv_295",
  "theme-border-dark-purple": "_theme-border-dark-purple_1t5uv_299",
  "theme-border-dark-gray": "_theme-border-dark-gray_1t5uv_303",
  "theme-border-light-red": "_theme-border-light-red_1t5uv_307",
  "theme-border-light-blue": "_theme-border-light-blue_1t5uv_311",
  "theme-border-light-orange": "_theme-border-light-orange_1t5uv_315",
  "theme-border-light-green": "_theme-border-light-green_1t5uv_319",
  "theme-border-light-purple": "_theme-border-light-purple_1t5uv_323",
  "theme-border-light-gray": "_theme-border-light-gray_1t5uv_327",
  "theme-gradient-red": "_theme-gradient-red_1t5uv_331",
  "theme-gradient-blue": "_theme-gradient-blue_1t5uv_335",
  "theme-gradient-orange": "_theme-gradient-orange_1t5uv_339",
  "theme-gradient-green": "_theme-gradient-green_1t5uv_343",
  "theme-gradient-purple": "_theme-gradient-purple_1t5uv_347",
  "content-card-link": "_content-card-link_1t5uv_351",
  "content-card-container": "_content-card-container_1t5uv_355",
  banner: Y,
  "content-card-image": "_content-card-image_1t5uv_367",
  "icon-container": "_icon-container_1t5uv_370",
  "download-icon-container": "_download-icon-container_1t5uv_389",
  "pdf-banner": "_pdf-banner_1t5uv_407",
  "pdf-banner-wrapper": "_pdf-banner-wrapper_1t5uv_416",
  content: A,
  "theme-dark-blue": "_theme-dark-blue_1t5uv_430",
  "theme-dark-green": "_theme-dark-green_1t5uv_434",
  "theme-dark-orange": "_theme-dark-orange_1t5uv_438",
  "theme-dark-red": "_theme-dark-red_1t5uv_442",
  "theme-dark-purple": "_theme-dark-purple_1t5uv_446",
  "theme-dark-gray": "_theme-dark-gray_1t5uv_450",
  "theme-light-blue": "_theme-light-blue_1t5uv_454",
  "theme-light-green": "_theme-light-green_1t5uv_458",
  "theme-light-orange": "_theme-light-orange_1t5uv_462",
  "theme-light-red": "_theme-light-red_1t5uv_466",
  "theme-light-purple": "_theme-light-purple_1t5uv_470",
  "theme-light-gray": "_theme-light-gray_1t5uv_474",
  header: P,
  tag: S,
  title: x,
  description: j,
  footer: q,
  "footer-line": "_footer-line_1t5uv_519",
  "resource-card-content": "_resource-card-content_1t5uv_526",
  "promotion-card-content": "_promotion-card-content_1t5uv_529",
  "resource-card-container": "_resource-card-container_1t5uv_533",
  seperator: D,
  "vertical-line": "_vertical-line_1t5uv_549",
  dot: E,
  "card-bg-color-light-orange": "_card-bg-color-light-orange_1t5uv_561",
  "card-bg-color-white": "_card-bg-color-white_1t5uv_565",
  "card-bg-color-amway-white": "_card-bg-color-amway-white_1t5uv_566",
  "card-bg-color-light-red": "_card-bg-color-light-red_1t5uv_570",
  "card-bg-color-light-blue": "_card-bg-color-light-blue_1t5uv_574",
  "card-bg-color-light-green": "_card-bg-color-light-green_1t5uv_578",
  "card-bg-color-light-yellow": "_card-bg-color-light-yellow_1t5uv_582",
  "card-bg-color-light-purple": "_card-bg-color-light-purple_1t5uv_586",
  "card-bg-color-light-gray": "_card-bg-color-light-gray_1t5uv_590",
  "card-color-dark-orange": "_card-color-dark-orange_1t5uv_594",
  "card-color-black": "_card-color-black_1t5uv_598",
  "card-color-amway-black": "_card-color-amway-black_1t5uv_599",
  "card-color-dark-red": "_card-color-dark-red_1t5uv_603",
  "card-color-dark-blue": "_card-color-dark-blue_1t5uv_607",
  "card-color-dark-green": "_card-color-dark-green_1t5uv_611",
  "card-color-dark-yellow": "_card-color-dark-yellow_1t5uv_615",
  "card-color-dark-purple": "_card-color-dark-purple_1t5uv_619"
};
export {
  F as s
};
//# sourceMappingURL=ContentCard.module-001e5939.mjs.map
